import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import KPICard from '../Common/KPICard';
import SubscriptionSeverityBar from './SubscriptionSeverityBar';

const AlertSubscriptionKPIs = ({
	subscribedAlerts,
	loading,
	alertsReceivedCount,
}) => {
	const subscribedCount = subscribedAlerts?.length || 0;

	// Get count at each severity level for SubscriptionSeverityBar
	// bar only includes subscribed alerts, not all alerts
	const getSeverityCount = (severity) =>
		subscribedAlerts.filter(
			(alert) => alert.severity?.toLowerCase() === severity
		).length;

	const warningCount = getSeverityCount('warning');
	const criticalCount = getSeverityCount('critical');
	const infoCount = getSeverityCount('info');

	return (
		<Box>
			<Typography
				variant='overline'
				sx={{
					fontSize: '11px',
					color: 'text.secondary',
					mb: '1px',
				}}
			>
				Your Activity
			</Typography>

			<Box display='flex' justifyContent='space-between' gap={2}>
				<Box flex={1}>
					<KPICard
						loading={loading}
						sub={'Subscribed'}
						tooltipForSub={"Number of alerts you're subscribed to"}
						value={subscribedCount?.toString() || '0'}
					/>
				</Box>

				<Box flex={1}>
					<KPICard
						loading={loading}
						sub={'Received 30d'}
						tooltipForSub={
							"Number of alerts you've received in the last 30 days"
						}
						value={alertsReceivedCount?.toString() || '0'}
					/>
				</Box>

				<Box flex={2}>
					<KPICard
						sub={'Severity mix'}
						tooltipForSub={'Distribution of your subscribed alerts by severity'}
					>
						<SubscriptionSeverityBar
							warning={warningCount}
							critical={criticalCount}
							info={infoCount}
							loading={loading}
						/>
					</KPICard>
				</Box>
			</Box>
		</Box>
	);
};

AlertSubscriptionKPIs.propTypes = {
	subscribedAlerts: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			subscribed: PropTypes.bool,
			createdAt: PropTypes.string,
			severity: PropTypes.string.isRequired,
		})
	),
	loading: PropTypes.bool,
	alertsReceivedCount: PropTypes.number,
};

export default AlertSubscriptionKPIs;
